import React, { useEffect, useState } from "react";
import { Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';
import { useTranslation } from "react-i18next";

import { mapChallengeType } from "@service/challengeService";

import { useChallengeTypesQuery } from "@query/challengeQuery";

import SmartTextareaInput from "./smartForm/SmartTextareaInput";

export function SelectChallengeType({ target, setTarget, sx }) {
    const { t } = useTranslation(["main", "challenges"]);
    const challengeTypesQuery = useChallengeTypesQuery();
    const [availableTypes, setAvailableTypes] = useState([]);

    useEffect(() => {
        if (challengeTypesQuery.data?.data) {
          const challengeTypes = challengeTypesQuery.data.data;
          setAvailableTypes(challengeTypes);
        }
    }, [challengeTypesQuery.data]);
    
    const handleTargetChange = (event) => {
        const value = event.target.value;
        setTarget(value);
    };

    const getTypeName = (type) => {
        return mapChallengeType(type.name)['translationKey'];
    }

    const getSelectedTypeDescription = () => {
        if (target) {
            const type = availableTypes.find(type => type.uuid === target);
            return  mapChallengeType(type.name)['descriptionKey'];
        }
        return " ";
    }

    if (!challengeTypesQuery.isSuccess) return null;
    
    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, ...sx}}>
            <FormControl fullWidth>
                <InputLabel sx={{top:'-5px'}}>{t("challenges:type")}</InputLabel>
                <Select
                    value={target}
                    onChange={handleTargetChange}
                    label={t("selectTarget")}
                    required
                >                    
                    
                    {availableTypes.map(type => (
                        <MenuItem 
                            key={`${type.uuid}`} 
                            value={`${type.uuid}`}
                        >
                            {t(getTypeName(type))}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            <SmartTextareaInput 
                value={t(getSelectedTypeDescription())} 
                editable={false} 
                // label={t("challenges:typeDescription")} 
                rows={3} 
                sx={{p:1}}
            />
        </Box>
    );
}